
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-statistics",
      function () {
        return require("private-next-pages/email-statistics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-statistics"])
      });
    }
  